module.exports = wp.serverSideRender;